<template>
  <div>
    免责声明
  </div>
</template>

<script>
  export default {
    name: 'SettingsDisclaimer'
  }
</script>

<style scoped>

</style>
